module.exports = __webpack_public_path__ + "static/img/handshake_2.71e1885.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/handshake_2.png
// module id = Dv/5
// module chunks = 1